import { useEffect, useState } from 'react'

export default function Badge ({ text, type = 'default' }: { text: string, type?: string }) {
  const [classes, setClasses] = useState('bg-gray-100 gray-800')

  useEffect(() => {
    switch (type) {
      case 'success':
        setClasses('bg-green-100 text-green-800')
        break
      case 'attention':
        setClasses('bg-yellow-100 text-yellow-800')
        break
      case 'warning':
        setClasses('bg-orange-100 text-orange-800')
        break
      case 'critical':
        setClasses('bg-red-100 text-red-800')
        break
      case 'info':
        setClasses('bg-thatch-purple-secondary text-white')
        break
      case 'highlight':
        setClasses('bg-cyan-100 text-cyan-800')
        break
      default:
        setClasses('bg-gray-100 gray-800')
    }
  }, [type])

  return (
    <span className={`inline-flex items-center rounded-[8px] px-2 py-1 text-xs leading-[18px] font-semibold ${classes}`}>
      {text}
    </span>
  )
}
